import React, { useEffect, useState } from 'react';
import Layout from '../../components/global/layout';
import Pagination from 'react-pagination-js';
import methodModel from '../../methods/methods';
import datepipeModel from '../../models/datepipemodel';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ApiClient from '../../methods/api/apiClient';
import { HiArrowSmUp } from 'react-icons/hi';
import { HiOutlineArrowDown } from 'react-icons/hi';

const Newsletters = () => {
  let user = useSelector((state) => state.user);
  const [loaging, setLoader] = useState(true);

  const searchState = useSelector((state) => state.search);
  const [filters, setFilter] = useState({
    page: 1,
    count: 10,
    search: '',
    sortBy: 'createdAt desc',
    key: '',
    sorder: 'asc',
  });

  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);



  const GetallData = (p = {}) => {
    let filter = { ...filters, ...p };
    setLoader(true);
    ApiClient.get(`NewsLetter/all`, filter).then((res) => {
      if (res.success) {
        setData(res?.data);
        setTotal(res?.total);
        setLoader(false);
      }
    });
  };
  useEffect(() => {
    if (user && user.loggedIn) {
      setFilter({ ...filters, search: searchState.data });
      GetallData({ search: searchState.data, page: 1 });
    }
  }, [searchState]);

  const sorting = (key) => {
    let sorder = 'asc';
    if (filters.key === key) {
      sorder = filters.sorder === 'asc' ? 'desc' : 'asc';
    }
    setFilter({ key, sorder });

    let sortBy = `${key} ${sorder}`;
    setFilter({ ...filters, sortBy, key, sorder });
    GetallData({ sortBy, key, sorder });
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    GetallData({ page: e });
  };

  const handleItemCountChange = (e) => {
    setFilter({ ...filters, page: 1, count: e?.target?.value });
    GetallData({ page: 1, count: e?.target?.value });
  };

  const renderSortIcon = (columnKey) => {
    if (filters.key !== columnKey)
      return <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
    else {
      if (filters.sorder === 'asc') {
        <HiArrowSmUp className="shrink-0 inline text-sm" />;
      } else {
        <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
      }
    }
    return filters.sorder === 'asc' ? (
      <HiArrowSmUp className="shrink-0 inline text-sm" />
    ) : (
      <HiOutlineArrowDown className="shrink-0 inline text-sm" />
    );
  };


  return (
    <>
      <Layout>
        <div className="flex justify-between items-center">
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">
              News Letters
            </h3>
            <p class="text-sm font-normal text-[#525252]">
              Here you can see all about your News Letters
            </p>
          </div>
        </div>

        <div className="shadow-lg w-full bg-white rounded-lg mt-6">
          <div className="scrollbar w-full overflow-auto">
            <table class="w-full">
              <thead className="text-xs text-gray-700 capitalize bg-gray-50  border-b border-[#EAECF0]">
                <tr className="border-b border-[#EAECF0]">
                  <th
                    scope="col"
                    onClick={(e) => sorting('email')}
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap "
                  >
                    Email{' '}
                    <span className="mr-2">{renderSortIcon('email')}</span>
                  </th>

                  <th
                    scope="col"
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                    onClick={(e) => sorting('createdAt')}
                  >
                    Subscribed At{' '}
                    <span className="mr-2">{renderSortIcon('createdAt')}</span>
                  </th>
                </tr>
              </thead>
              <tbody id="tableBodycat">
                {data &&
                  data?.map((itm, i) => {
                    return (
                      <tr className="">
                        <td
                          className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]"
                        >
                          <h4 className="user">
                            {itm?.email}
                          </h4>
                        </td>

                        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          {datepipeModel.date(itm.createdAt)}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          {!loaging && data?.length === 0 ? (
            <div className="py-3 text-center text-[#8b8b8b]">No Data</div>
          ) : (
            <></>
          )}
          {total > 10 ? (
            <div className="paginationWrapper  mt-15">
              <span className='text-sm text-gray-600'>Show {filters.count} from {total} News Letters
              </span>
              <select
                className="border-[1px] border-[#cfd5dc] rounded-[5px] px-[5px] py-[5px] bg-white text-[12px] mr-3"
                value={filters.count} // Current value of items per page
                onChange={(e) => handleItemCountChange(e)} // Function to handle changes
              >
                {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((count) => (
                  <option key={count} value={count}>
                    {count}
                  </option>
                ))}
              </select>
              <Pagination
                currentPage={filters.page}
                totalSize={total}
                sizePerPage={filters.count}
                changeCurrentPage={pageChange}
              />

            </div>
          ) : (
            <></>
          )}
          {loaging ? (
            <div className="text-center py-4">
              <img src="/assets/img/loader.gif" className="pageLoader" />
            </div>
          ) : (
            <></>
          )}
        </div>
      </Layout>
    </>
  );
};
export default Newsletters;
